import { render, staticRenderFns } from "./AugmentingMedication.vue?vue&type=template&id=40d7b84b&scoped=true&"
import script from "./AugmentingMedication.vue?vue&type=script&lang=js&"
export * from "./AugmentingMedication.vue?vue&type=script&lang=js&"
import style0 from "./AugmentingMedication.vue?vue&type=style&index=0&id=40d7b84b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d7b84b",
  null
  
)

export default component.exports